import React from 'react'
import { StyleSheet, Text, View, TouchableOpacity } from 'react-native'
import { Ionicons, Entypo, FontAwesome } from '@expo/vector-icons'
import { useTranslation } from 'react-i18next'
import { fontPalette } from '../../../../static/styles/global'

interface NavigationCardsProps {
  navigation: any
  customerShifts: any[]
  announcementsCount: number
  hasLabourSavour: boolean
}

const NavigationCards = ({
  navigation,
  customerShifts,
  announcementsCount,
  hasLabourSavour
}: NavigationCardsProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <View style={styles.container}>
      {/* My Schedule Card */}
      {hasLabourSavour &&
        <>
          <TouchableOpacity
            style={styles.card}
            onPress={() => navigation.navigate('WeeklySummary')}
          >
            <View style={[styles.iconCircle, { backgroundColor: '#A84499' }]}>
              <FontAwesome name="calendar" size={18} color="white" />
            </View>
            <Text style={styles.titleText}>{t('My Schedule')}</Text>
            <Text style={styles.subtitleText}>{t('View your shifts')}</Text>
            <View style={styles.arrowContainer}>
              <Entypo name="chevron-right" size={16} color="#888" />
            </View>
          </TouchableOpacity>


          {/* Timecard Card */}
          <TouchableOpacity
            style={styles.card}
            onPress={() => navigation.navigate('TimeCard', { customerShifts })}
          >
            <View style={[styles.iconCircle, { backgroundColor: '#BEA02F' }]}>
              <Ionicons name="time" size={18} color="white" />
            </View>
            <Text style={styles.titleText}>{t('Timecard')}</Text>
            <Text style={styles.subtitleText}>{t('View your time')}</Text>
            <View style={styles.arrowContainer}>
              <Entypo name="chevron-right" size={16} color="#888" />
            </View>
          </TouchableOpacity>
        </>}

      {/* Announcements Card */}
      <TouchableOpacity
        style={styles.card}
        onPress={() => navigation.navigate('AnnouncementsScreen')}
      >
        <View style={[styles.iconCircle, { backgroundColor: '#9DD086' }]}>
          <Entypo name="megaphone" size={18} color="white" />
        </View>
        <Text style={styles.titleText}>{t('announcements')}</Text>
        <Text style={styles.subtitleText}>
          {announcementsCount > 0
            ? `${announcementsCount} ${t('new')}`
            : t('No new')}
        </Text>
        <View style={styles.arrowContainer}>
          <Entypo name="chevron-right" size={16} color="#888" />
        </View>
      </TouchableOpacity>
    </View>
  )
}

export default NavigationCards

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    marginVertical: 15
  },
  card: {
    flex: 1,
    backgroundColor: 'white',
    borderRadius: 12,
    paddingVertical: 16,
    paddingHorizontal: 8,
    alignItems: 'center',
    marginHorizontal: 5,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 8,
    elevation: 2,
    position: 'relative',
    minHeight: 140,
    justifyContent: 'space-between',
    maxWidth: "33%"
  },
  iconCircle: {
    width: 44,
    height: 44,
    borderRadius: 22,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 8
  },
  titleText: {
    fontSize: 11,
    fontFamily: fontPalette.primaryBold,
    color: '#111',
    textAlign: 'center'
  },
  subtitleText: {
    fontSize: 10,
    color: '#777',
    marginTop: 4,
    textAlign: 'center'
  },
  arrowContainer: {
    marginTop: 8,
    alignItems: 'center',
    justifyContent: 'center'
  }
})
